import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Applications, Consult, Guilds, GuildUsers, OffersPage } from '../../pages'
import {
  PrivateAreaNavigationGuidePage,
  MarketerUsers,
  Profile,
  NewNedgiaAppsPage,
  PrescriptorInstallersPage,
} from '../../pages'
import { Tariffs, Users, MarketerPotential, Inspections, IP, JCA, Boilers } from '../../pages'
import { CorporateIdentityPage, AssociatesIP3, EIDetail, AdministrativeLeaves } from '../../pages'

export const usePrivateRoutes = () => {
  const global = useSelector((state) => state.global)

  const getPrivateRoutes = useCallback(() => {
    let router = {}
    switch (global.role) {
      case 'gremio':
        router = {
          routes: [
            { path: '/guildUsers', component: GuildUsers },
            { path: '/profile', component: Profile },
            { path: '/private-area-navigation-guide', component: PrivateAreaNavigationGuidePage },
            { path: '/otherApps', component: NewNedgiaAppsPage },
            { path: '/corporative-identity', component: CorporateIdentityPage },
          ],
          redirect: '/profile',
        }
        if (global.gremio?.captadora) {
          router.routes.push({ path: '/applications', component: Applications })
          router.routes.push({ path: '/offers', component: OffersPage })
          router.routes.push({ path: '/associates/:id', component: EIDetail })
          router.routes.push({ path: '/associates', component: Guilds })
          // NEVO-439: /consult (datos de potencial) restringido; /consult2 (caldera centralizada) permitido
          router.routes.push({ path: '/consult2', component: Boilers })
          router.redirect = '/applications'
        }
        if (global.gremio?.grabadora) {
          router.routes.push({ path: '/associates-ip3', component: AssociatesIP3 })
          router.routes.push({ path: '/ip', component: IP })
          router.routes.push({ path: '/jca', component: JCA })
          router.routes.push({ path: '/inspections/:inspectionType', component: Inspections })
        }
        break
      case 'comercializadora':
        router = {
          routes: [
            { path: '/profile', component: Profile },
            { path: '/marketerUsers', component: MarketerUsers },
            { path: '/marketerPotential', component: MarketerPotential },
            { path: '/administrativeLeaves', component: AdministrativeLeaves },
          ],
          redirect: '/marketerUsers',
        }
        break
      case 'administrador':
      case 'instalador':
        router = {
          routes: [
            { path: '/profile', component: Profile },
            // NEVO-439: /applications y /consult2 (caldera centralizada) restaurados.
            // /consult (datos de potencial) permanece restringido.
            { path: '/applications', component: Applications },
            { path: '/consult2', component: Boilers },
            { path: '/tariffs', component: Tariffs },
            { path: '/users', component: Users },
            { path: '/offers', component: OffersPage },
            { path: '/private-area-navigation-guide', component: PrivateAreaNavigationGuidePage },
            { path: '/otherApps', component: NewNedgiaAppsPage },
            { path: '/corporative-identity', component: CorporateIdentityPage },
          ],
          redirect: '/applications',
        }
        break
      case 'administrador_grabador':
      case 'instalador_grabador':
        router = {
          routes: [
            { path: '/profile', component: Profile },
            { path: '/users', component: Users },
            { path: '/inspections/:inspectionType', component: Inspections },
            { path: '/ip', component: IP },
            { path: '/jca', component: JCA },
          ],
          redirect: '/profile',
        }
        break
      case 'admin_captador_grabador':
      case 'instalador_captador_grabador':
        router = {
          routes: [
            { path: '/profile', component: Profile },
            // NEVO-439: /applications y /consult2 (caldera centralizada) restaurados.
            // /consult (datos de potencial) permanece restringido.
            { path: '/applications', component: Applications },
            { path: '/consult2', component: Boilers },
            { path: '/tariffs', component: Tariffs },
            { path: '/users', component: Users },
            { path: '/offers', component: OffersPage },
            { path: '/private-area-navigation-guide', component: PrivateAreaNavigationGuidePage },
            { path: '/otherApps', component: NewNedgiaAppsPage },
            { path: '/corporative-identity', component: CorporateIdentityPage },
            { path: '/inspections/:inspectionType', component: Inspections },
            { path: '/ip', component: IP },
            { path: '/jca', component: JCA },
          ],
          redirect: '/applications',
        }
        break
      case 'administrador_prescriptor': {
        const adhesionRedirect = sessionStorage.getItem('apins-adhesion-redirect')
        if (adhesionRedirect) {
          sessionStorage.removeItem('apins-adhesion-redirect')
        }
        router = {
          routes: [
            { path: '/profile', component: Profile },
            { path: '/users', component: Users },
            { path: '/consult', component: Consult },
            { path: '/applications', component: Applications },
            { path: '/offers', component: OffersPage },
            { path: '/prescriptor-installers', component: PrescriptorInstallersPage },
            { path: '/private-area-navigation-guide', component: PrivateAreaNavigationGuidePage },
            { path: '/corporative-identity', component: CorporateIdentityPage },
          ],
          redirect: adhesionRedirect || '/consult',
        }
        break
      }
      default:
        router = { routes: [{ path: '/profile', component: Profile }], redirect: '/profile' }
    }

    return router
  }, [global])

  return { getPrivateRoutes }
}
